// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3dtvS","footer":"ModalError_footer__35Zk8"};